(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["divano-delivery-offer"] && !Shopify.designMode) return;
  try {
    (() => {
    if (!window.customElements || customElements.get('divano-delivery-offer')) return;

    const impressions = new Set();

    class DivanoDeliveryOffer extends HTMLElement {
      static get observedAttributes() {
        return ['data-campaign', 'data-placement', 'data-phase', 'data-offer-id'];
      }

      connectedCallback() {
        this.onClick ||= (event) => {
          if (event.target.closest('.divano-delivery-offer__link')) {
            this.publish('divano_hero_click');
          }
        };
        this.addEventListener('click', this.onClick);
        this.observeImpression();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.removeEventListener('click', this.onClick);
      }

      attributeChangedCallback() {
        if (this.isConnected) this.observeImpression();
      }

      get payload() {
        return {
          campaign: this.dataset.campaign || '',
          placement: this.dataset.placement || '',
          device: matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop'
        };
      }

      publish(name) {
        if (!this.payload.campaign || !this.payload.placement) return;
        try { window.Shopify?.analytics?.publish?.(name, this.payload); } catch (e) {  }
      }

      observeImpression() {
        this.observer?.disconnect();
        const payload = this.payload;
        const key = JSON.stringify([this.dataset.offerId, payload.campaign, payload.placement, this.dataset.phase || 'main']);
        if (!payload.campaign || !payload.placement || impressions.has(key) || !('IntersectionObserver' in window)) return;
        const observer = new IntersectionObserver((entries) => {
          if (!this.isConnected || this.observer !== observer || !entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.5)) return;
          observer.disconnect();
          if (impressions.has(key)) return;
          impressions.add(key);
          this.publish('divano_hero_impression');
        }, { threshold: 0.5 });
        this.observer = observer;
        observer.observe(this);
      }
    }

    customElements.define('divano-delivery-offer', DivanoDeliveryOffer);
  })();
  } catch(e) { console.error(e); }
})();

})();
